/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsAlignJustify: {
  name: 'align-justify';
  data: string;
} = {
  name: 'align-justify',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 5a1 1 0 0 0 0 2h16a1 1 0 1 0 0-2H4Zm0 4a1 1 0 0 0 0 2h16a1 1 0 1 0 0-2H4Zm-1 5a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2H4Z" fill="currentColor"/></svg>`,
};
